export default "__VITE_ASSET__DUKfCnGV__"